import { Label } from '@primer/react';
import * as React from 'react';
export default {
  Label,
  React
};